<template>
  <div class="oMonitoringData" ref="meRunningTime">
    <div class="omdBox">
      <div class="boxLeft">
        <div class="tips"></div>
        <div class="total">
          <div>
            <span>在线(台)</span>
            <count-too :value="eqiOnline" class="color1 boldNumber"></count-too>
          </div>
          <div>
            <span>总数(台)</span>
            <count-too :value="eqiTotal" class="color2 boldNumber"></count-too>
          </div>
        </div>
      </div>
      <div class="boxRight">
        <div class="rightTitle">
          <div class="titleItem" :style="{ width: rightItemWidth[i] }" v-for="(item, i) in rightTitleList" :key="i">
            {{ item }}
          </div>
        </div>
        <div class="rightList">
          <div class="listItem" v-for="(item, i) in rightList" :key="i">
            <div :style="{ width: rightItemWidth[0] }">{{ item.metric }}</div>
            <div :style="{ width: rightItemWidth[1] }">
              <div :style="{ textAlign: customerId == 89 ? 'center' : '' }">
                <count-too class="color3 number" :value="item.avgValue" :decimals='2'>
                </count-too>
              </div>
              <div>{{ item.unit }}</div>
            </div>
            <div v-if="customerId != 89" :style="{ width: rightItemWidth[2] }">
              <div>
                <count-too class="color4 number" :value="item.maxValue" :decimals='2'>
                </count-too>
              </div>
              <div>{{ item.unit }}</div>
            </div>
            <div v-if="customerId != 89" :style="{ width: rightItemWidth[3] }">
              <div>
                <count-too class="color5 number" :value="item.minValue" :decimals='2'>
                </count-too>
              </div>
              <div>{{ item.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countToo from "@/components/vueCountTo";
export default {
  components: { countToo },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'O_monitoringData.vue',
      computedName: '有组织监控数据组件',
      customerId: this.$store.state.customerId,
      eqiOnline: null,
      eqiTotal: null,
      rightTitleList: ["监测指标", "平均值", "最大值", "最小值"],
      rightList: [
        { type: "PM10", unit: "ug/m³", avg: 55.63, max: 1999.9, min: 34 },
        { type: "TSP", unit: "mg/m³", avg: 4.29, max: 7.77, min: 2.78 },
        { type: "含水率", unit: "%", avg: 6.4, max: 8.9, min: 3.8 },
      ],
      rightItemWidth: ["25%", "26%", "26%", "23%"],
      getlistTimer: null,
    };
  },
  computed: {},
  mounted() {
    let that = this;
    let w = $(that.$refs.meRunningTime).outerWidth();
    let h = $(that.$refs.meRunningTime).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    // this.test();
    this.getListData();
    if(window.bmeConfig.customerSign == 89) {
      this.rightTitleList = ["监测指标", "平均值"];
      this.rightItemWidth = ['50%', '50%'];
    } else {
      this.rightTitleList = ["监测指标", "平均值", "最大值", "最小值"];
      this.rightItemWidth = ["25%", "26%", "26%", "23%"];
    }
  },
  unmounted() {
    this.clearTimer(this.getlistTimer, false);
  },
  methods: {
    // 每小时获取列表
    async getListData() {
      this.clearTimer(this.getlistTimer);
      let getOmonitoringData =
        CONFIG.requestName + this.$apiOpt.getOmonitoringData;
      let res = await this.$apiUtils.get(getOmonitoringData, {
        customerId: this.customerId,
      });
      if (res) {
        let data = JSON.parse(JSON.stringify(res));
        this.rightList = data.list;
        this.eqiOnline = data.online;
        this.eqiTotal = data.total;
      }
      this.getlistTimer = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 5);
    },
    // 清除定时器
    clearTimer(timer, isInterval = true) {
      if (timer) {
        isInterval ? clearInterval(timer) : clearTimeout(timer);
        timer = null;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped="scoped">
.oMonitoringData {
  height: 250px;
  width: 600px;
  .omdBox {
    margin-top: 35px;
    display: flex;
    .boxLeft {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .tips {
        width: 141px;
        height: 53px;
        background: url("./img/cems.png") no-repeat 100%;
      }
      .total {
        width: 70%;
        flex: 1;
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > div {
          display: flex;
          justify-content: space-between;
          line-height: 100%;
          > span:nth-child(2) {
            font-size: 36px;
          }
          .color1 {
            color: rgba(71, 255, 221, 1);
          }
          .color2 {
            color: rgba(244, 196, 143, 1);
          }
        }
      }
    }
    .boxRight {
      //background: url("./img/border.png") no-repeat;
      width: 382px;
      height: 180px;
      text-align: center;
      .rightTitle {
        display: flex;
        background: rgba(20, 41, 118, 0.57);
        height: 30px;
        line-height: 30px;
      }
      .rightList {
        .listItem {
          height: 49px;
          line-height: 49px;
          display: flex;
          text-indent: 4px;
          font-size: 18px;
          .color3 {
            color: rgba(145, 209, 249, 1);
          }
          .color4 {
            color: rgba(254, 131, 131, 1);
          }
          .color5 {
            color: rgba(174, 255, 177, 1);
          }
          > :not(:first-child) {
            padding: 0 6px;
            > :nth-child(1) {
              height: 32px;
              line-height: 32px;
              text-align: left;
            }
            > :nth-child(2) {
              font-size: 10px;
              height: 12px;
              line-height: 12px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>
